<template>
  <v-menu
    :value="value"
    absolute
    :position-x="x"
    :position-y="y"
    :close-on-click="true"
    :close-on-content-click="true"
    @input="$emit('input', $event)"
  >
    <v-list>
    <v-list-item v-for="(item, index) in contextMenuList" :key="index" @click="item.method" class="context-menu-item-container">
        <div v-if="item.isSeparator" class="context-menu-item-separator"/>
        <div v-else class="context-menu-item-content">
          <dr-svg :image="item.icon" :color="iconColor" :size="iconSize"></dr-svg>
          <v-list-item-title class="context-menu-item-text">{{ item.title }}</v-list-item-title>
        </div>
      </v-list-item>
    </v-list>
  </v-menu>
</template>
<script>
import drSvg from '../customWidgets/dr-svg.vue'
export default {
  props: {
    value: Boolean,
    isAppInIFrame: Boolean,
    isDrListViewNormal: Boolean,
    itemHaveInFavorite: Boolean,
    x: Number,
    y: Number
  },
  data: () => ({
    iconColor: '#5d5a5a',
    iconSize: 24
  }),

  components: {
    drSvg
  },
  computed: {
    contextMenuList () {
      let menu = []
      menu.push({ title: this.$t('menuLayout.contextMenu.openInNewTab'), sort: 0, icon: '', method: () => this.$emit('openInNewTab') })
      menu.push({ title: this.$t('menuLayout.share'), sort: 2, icon: 'SHARE_LINK', method: () => this.$emit('toShare') })
      menu.push({ isSeparator: true, method: () => { } })
      
      //TODO: Реализация в iframe RMD
      if (this.isAppInIFrame) {
        //menu.push({ title: this.$t('menuLayout.contextMenu.runFromGroup'), sort: 1, icon: '', method: () => this.$emit('deleteComponent', this.widgetModel) })
        menu.push({ title: this.$t('menuLayout.contextMenu.accessSettingsCurrentGroup'), sort: 3, icon: 'TB_ICM', method: () => this.$emit('menuSettingsAccess', false) })
        menu.push({ title: this.$t('menuLayout.contextMenu.accessSettingsAllGroups'), sort: 4, icon: 'GROUP_SETTINGS', method: () => this.$emit('menuSettingsAccess', true) })
        menu.push({ isSeparator: true, method: () => { } })
      }

      if (this.isDrListViewNormal) {
        menu.push({ title: this.$t('menuLayout.contextMenu.rename'), sort: 5, icon: 'SCREDIT_LABEL', method: () => this.$emit('openRenameDialog') })
      }

      if (this.itemHaveInFavorite) {
        menu.push({ title: this.$t('menuLayout.contextMenu.remove'), sort: 6, icon: 'STAR_BORDER', method: () => this.$emit('removeFromFavorite') })
      } else {
        menu.push({ title: this.$t('menuLayout.contextMenu.addToFavorite'), sort: 7, icon: 'STAR', method: () => this.$emit('addToFavorite') })
      }

      menu.sort((a, b) => a.sort - b.sort)

      return menu
    }
  }
  
}
</script>

<style>
.context-menu-item-text {
  margin-top: var(--context-menu-padding-top-bot);
  margin-bottom: var(--context-menu-padding-top-bot);
  font-size: var(--context-menu-font-size);
  min-height: 24px;
  align-items: center;
  display: flex;
}
.context-menu-item-content svg {
  width: 24px;
  min-width: 24px;
  height: 24px;
  min-height: 24px;
  margin: var(--context-menu-padding-top-bot) 10px;
}
.context-menu-item-container {
  min-height: 0px;
  padding: 0px;
}
.context-menu-item-separator {
  border-top: 1px solid #eee;
  width: 100%;
}
.context-menu-item-content {
  display: flex;
  width: 100%;
  padding: 0px 30px 0px 0px;
}
.context-menu-item-container:hover{
  background: #eaeaea;
}
</style>